import api from 'api'
import { Shifts } from 'pages/Shifts/Shifts/types'

export const NotSetAccountOrSalesOwnerFilterId = 'not-set' as const

type GetAllShiftsRequest = {
  page: number
  pageSize: number
  rangeType?: 'past' | 'ongoing' | 'upcoming'
  startDate?: string
  endDate?: string
  shiftIds?: number[]
  marketCodes?: string[]
  companyIds?: number[]
  companyGroupIds?: number[]
  salesOwnerIds?: (typeof NotSetAccountOrSalesOwnerFilterId | number)[]
  accountOwnerIds?: (typeof NotSetAccountOrSalesOwnerFilterId | number)[]
  scheduleRateMin?: number
  scheduleRateMax?: number
  fillRateMin?: number
  fillRateMax?: number
  locationIds?: number[]
  listingIds?: number[]
  shiftStatuses?: ('active' | 'cancelled')[]
  companyTypes?: ('1099' | 'w2')[]
  positionIds?: number[]
  rosterRestrictions?: ('permanent' | 'temporary' | 'non-roster')[]
  isStandby?: boolean
}

type GetAllShiftsResponse = {
  items: Shifts
  totalRows: number
}

export const getAllShifts = async (
  request: GetAllShiftsRequest
): Promise<GetAllShiftsResponse> => {
  const response = await api.get<GetAllShiftsResponse>('/admin/shift/all', {
    params: {
      account_owner_ids: request.accountOwnerIds,
      company_group_ids: request.companyGroupIds,
      company_ids: request.companyIds,
      company_types: request.companyTypes,
      end_date: request.endDate,
      fill_rate_max: request.fillRateMax,
      fill_rate_min: request.fillRateMin,
      is_standby: request.isStandby,
      listing_ids: request.listingIds,
      location_ids: request.locationIds,
      market_codes: request.marketCodes,
      page_size: request.pageSize,
      page: request.page,
      position_ids: request.positionIds,
      range_type: request.rangeType,
      roster_restrictions: request.rosterRestrictions,
      sales_owner_ids: request.salesOwnerIds,
      schedule_rate_max: request.scheduleRateMax,
      schedule_rate_min: request.scheduleRateMin,
      shift_ids: request.shiftIds,
      shift_statuses: request.shiftStatuses,
      start_date: request.startDate,
    },
  })
  return response.data
}
